import { KioskStatus, TableKiosk, TableKioskType, TableStatus } from '@api/TablesKiosks/TableKiosk';
import TableKioskServ from '@api/TablesKiosks/TableKioskServ';

class TableKioskService {
    saveTableKiosk = (tableKiosk: TableKiosk): Promise<TableKiosk> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await TableKioskServ.saveTableKiosk(tableKiosk);
                resolve(data);
            } catch (error) {
                reject('Error saving table/kiosk: ' + error);
            }
        });
    };

    getTablesKiosks = (branchOfficeId?: string): Promise<TableKiosk[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await TableKioskServ.getTablesKiosks(branchOfficeId);
                resolve(data);
            } catch (error) {
                reject('Error getting tables/kiosks: ' + error);
            }
        });
    };

    getTablesKiosksRealtime = (
        branchOfficeId: string,
        callback: (tablesKiosks: TableKiosk[]) => void
    ): (() => void) => {
        try {
            return TableKioskServ.getTablesKiosksRealtime(branchOfficeId, callback);
        } catch (error) {
            console.error('Error setting up realtime listener:', error);
            return () => {};
        }
    };

    deleteTableKiosk = (tableKioskId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await TableKioskServ.deleteTableKiosk(tableKioskId);
                resolve();
            } catch (error) {
                reject('Error deleting table/kiosk: ' + error);
            }
        });
    };

    toggleStatus = (tableKioskId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await TableKioskServ.toggleStatus(tableKioskId);
                resolve();
            } catch (error) {
                reject('Error updating table/kiosk status: ' + error);
            }
        });
    };

    updateTableStatus = (tableId: string, status: TableStatus): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await TableKioskServ.updateTableStatus(tableId, status);
                resolve();
            } catch (error) {
                reject('Error updating table status: ' + error);
            }
        });
    };

    updateKioskStatus = (kioskId: string, status: KioskStatus): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await TableKioskServ.updateKioskStatus(kioskId, status);
                resolve();
            } catch (error) {
                reject('Error updating kiosk status: ' + error);
            }
        });
    };

    getTables = (branchOfficeId?: string): Promise<TableKiosk[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const allTablesKiosks = await TableKioskServ.getTablesKiosks(branchOfficeId);
                const tables = allTablesKiosks.filter((item) => item.type === TableKioskType.TABLE);
                resolve(tables);
            } catch (error) {
                reject('Error getting tables: ' + error);
            }
        });
    };

    getKiosks = (branchOfficeId?: string): Promise<TableKiosk[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const allTablesKiosks = await TableKioskServ.getTablesKiosks(branchOfficeId);
                const kiosks = allTablesKiosks.filter((item) => item.type === TableKioskType.KIOSK);
                resolve(kiosks);
            } catch (error) {
                reject('Error getting kiosks: ' + error);
            }
        });
    };
}

export default TableKioskService;
